import React from 'react'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import HomeImproved from './HomeImproved'
import {
  getHomeOverview,
  getHomeRecentJobs,
  getHomeRecentDevices
} from '../../redux/actions/homeActions'
import { getAppSetting } from '../../redux/actions/appSettingActions'

class Home extends React.Component<any, any> {
  jobsSearchTimer: any = null
  devicesSearchTimer: any = null

  state = {
    jobsPage: 1,
    jobsPageSize: 10,
    jobsSearch: '',
    devicesPage: 1,
    devicesPageSize: 10,
    devicesSearch: ''
  }

  componentDidMount() {
    this.props.refreshAppSettings()
    this.props.loadHomeOverview()
    this.props.loadRecentJobs(this.state.jobsPageSize, this.state.jobsPage, this.state.jobsSearch)
    this.props.loadRecentDevices(this.state.devicesPageSize, this.state.devicesPage, this.state.devicesSearch)
  }

  componentWillUnmount() {
    if (this.jobsSearchTimer) {
      clearTimeout(this.jobsSearchTimer)
    }

    if (this.devicesSearchTimer) {
      clearTimeout(this.devicesSearchTimer)
    }
  }

  handleRefresh = () => {
    this.props.refreshAppSettings()
    this.props.loadHomeOverview()
    this.props.loadRecentJobs(this.state.jobsPageSize, this.state.jobsPage, this.state.jobsSearch)
    this.props.loadRecentDevices(this.state.devicesPageSize, this.state.devicesPage, this.state.devicesSearch)
  }

  handleJobsPageChange = (pageNumber: number) => {
    this.setState({ jobsPage: pageNumber })
    this.props.loadRecentJobs(this.state.jobsPageSize, pageNumber, this.state.jobsSearch)
  }

  handleDevicesPageChange = (pageNumber: number) => {
    this.setState({ devicesPage: pageNumber })
    this.props.loadRecentDevices(this.state.devicesPageSize, pageNumber, this.state.devicesSearch)
  }

  handleJobsSearchChange = (value: string) => {
    this.setState({ jobsSearch: value, jobsPage: 1 })
    if (this.jobsSearchTimer) {
      clearTimeout(this.jobsSearchTimer)
    }

    this.jobsSearchTimer = setTimeout(() => {
      this.props.loadRecentJobs(this.state.jobsPageSize, 1, value)
    }, 300)
  }

  handleDevicesSearchChange = (value: string) => {
    this.setState({ devicesSearch: value, devicesPage: 1 })
    if (this.devicesSearchTimer) {
      clearTimeout(this.devicesSearchTimer)
    }

    this.devicesSearchTimer = setTimeout(() => {
      this.props.loadRecentDevices(this.state.devicesPageSize, 1, value)
    }, 300)
  }

  render() {
    const {
      translate,
      homeReducer,
      user,
      onRefresh,
      activeFeatures,
      servicesUrl,
      shopUrl,
      helpUrl,
      impersonating,
      softwareUpdate
    } = this.props

    const overview = homeReducer?.overview || {}
    const jobs = homeReducer?.recentJobs?.data || []
    const devices = homeReducer?.recentDevices?.data || []
    const jobsPagination = homeReducer?.recentJobs?.pagination
    const devicesPagination = homeReducer?.recentDevices?.pagination
    const isLoading = homeReducer?.loading || false

    return (
      <HomeImproved
        translate={translate}
        jobs={{ data: jobs }}
        devices={{ data: devices }}
        jobsPagination={jobsPagination}
        devicesPagination={devicesPagination}
        jobsPage={this.state.jobsPage}
        devicesPage={this.state.devicesPage}
        jobsSearch={this.state.jobsSearch}
        devicesSearch={this.state.devicesSearch}
        onJobsPageChange={this.handleJobsPageChange}
        onDevicesPageChange={this.handleDevicesPageChange}
        onJobsSearchChange={this.handleJobsSearchChange}
        onDevicesSearchChange={this.handleDevicesSearchChange}
        user={user}
        overview={overview}
        isLoading={isLoading}
        onRefresh={this.handleRefresh}
        activeFeatures={activeFeatures}
        servicesUrl={servicesUrl}
        shopUrl={shopUrl}
        helpUrl={helpUrl}
        impersonating={impersonating}
        softwareUpdate={softwareUpdate}
      />
    )
  }
}

const mapStateToProps = state => {
  const userFromState = state.userReducer?.user
  const translate = getTranslate(state.localeReducer)
  const fullName = userFromState?.firstname && userFromState?.lastname
    ? `${userFromState.firstname} ${userFromState.lastname}`
    : userFromState?.firstname || userFromState?.email || translate('default_user_name')

  return {
    homeReducer: state.homeReducer,
    translate,
    user: { ...userFromState, name: fullName },
    activeFeatures: state.appSettingReducer?.activeFeatures ?? null,
    servicesUrl: state.appSettingReducer?.servicesUrl || 'https://www.trend-networks.com/support/service-warranty/',
    shopUrl: state.appSettingReducer?.shopUrl || 'https://www.trend-networks.com/where-to-buy/',
    helpUrl: state.appSettingReducer?.helpUrl || 'https://www.trend-networks.com/support/downloads/',
    impersonating: state.userReducer?.impersonating || false,
    softwareUpdate: state.userReducer?.softwareUpdate || false,
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  refreshAppSettings: () => {
    dispatch(getAppSetting())
  },
  loadHomeOverview: () => {
    dispatch(getHomeOverview())
  },
  loadRecentJobs: (pageSize = 10, pageNumber = 1, search = '') => {
    dispatch(getHomeRecentJobs(pageSize, pageNumber, search))
  },
  loadRecentDevices: (pageSize = 10, pageNumber = 1, search = '') => {
    dispatch(getHomeRecentDevices(pageSize, pageNumber, search))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)
